import React, { Component } from 'react';
import createDecorator from 'final-form-focus';

const focusOnError = createDecorator();

export default function FocusHOC(HocComponent) {
  return class FocusCmp extends Component {
    render() {
      let decorators = this.props.decorators || [];
      decorators = decorators.concat(focusOnError);
      return <HocComponent decorators={decorators} {...this.props} />;
    }
  };
}
